import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# 📨 How to Create a Request

Follow the steps below to create a new request inside a collection or folder.

---

## ➕ Step 1: Add Request

Click on the vertical **⋯ (three dots)** menu under your selected **collection or folder**, then choose **Add Request** from the dropdown.

![Add Request Menu](/getting-started/createRequest1.png)

---

## ✏️ Step 2: Name the Request

A dialog box will appear in the center of the screen asking for the **request name**.

- Enter a **unique request name**
- Click the **Create** button at the bottom of the dialog

![Request Name Dialog](/getting-started/createRequest2.png)

---

## ✅ Step 3: Start Using the Request

Your request is now created successfully.

You can proceed to configure:
- URL
- Headers
- Authorization
- Request body

…and send your **first API request** 🚀
`;

const CreateRequest = () => {
    return (
        <MarkDownRenderer
            title="Create Request"
            markDownText={markdownContent}
        />
    );
};

export default CreateRequest;
